import { canEdit, isSeriesInstance } from 'owa-calendar-event-capabilities';
import getEditMenuItems from '../../helpers/getEditMenuItems';
import { CalendarEvent } from 'owa-calendar-types';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { edit } from 'owa-locstrings/lib/strings/edit.locstring.json';
import EventScope from 'owa-service/lib/contract/EventScope';

/**
 * Returns the edit button on the command bar if needed
 * @param event calendar event
 * @param composeEntrySource entry source
 * @param onEditClicked edit button callback
 * @param onMenuOpened callback for opening the menu
 */
export const getEditButton = (
    event: CalendarEvent,
    composeEntrySource: string,
    onEditClicked: (eventScope: EventScope) => void,
    onMenuOpened?: () => void
): FilterableMenuItem => {
    let onClick;
    let menuItems;

    if (!isSeriesInstance(event)) {
        onClick = () => onEditClicked(EventScope.Default);
    } else {
        onClick = onMenuOpened;
        menuItems = getEditMenuItems(event, composeEntrySource, (event, entrySource, eventScope) =>
            onEditClicked(eventScope)
        );
    }

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(edit),
        [FilterableMenuItemArgs.icon]: ControlIcons.Edit,
        [FilterableMenuItemArgs.onClick]: onClick,
        [FilterableMenuItemArgs.shouldShow]: () => canEdit(event) && onEditClicked !== null,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.menuContent]: menuItems,
        [FilterableMenuItemArgs.key]: 'Edit',
    });
};
